module.exports = __webpack_public_path__ + "8c2909e4fa6969a53784941b2cee0a50.pdf";